/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { useReducer, createContext, useEffect, ReactNode, Dispatch } from 'react'
import axios from 'axios'
import { UserRoleEnum } from 'generated/api'

export interface IUserInfo {
  role: UserRoleEnum
}

export interface IListRoles {
  roles: []
}
interface ISigninActionPayload {
  token: string | null
  userInfo: IUserInfo | null
}
interface IProps {
  children?: ReactNode
}

export enum UserTypes {
  SIGN_IN = 'SIGN_IN',
  SIGN_OUT = 'SIGN_OUT',
  DEFAULT = 'DEFAULT'
}

type State = {
  token: string | null
  userInfo: IUserInfo | null
}

type SignInAction = {
  type: typeof UserTypes.SIGN_IN
  payload: ISigninActionPayload
}

type SignoutAction = {
  type: typeof UserTypes.SIGN_OUT
}

type DefaultAction = {
  type: typeof UserTypes.DEFAULT
}

type UserActionTypes = SignInAction | SignoutAction | DefaultAction

export const UserContext = createContext<[State, Dispatch<UserActionTypes>]>([
  { token: null, userInfo: null },
  () => {}
])

const initialState: State = {
  token: null,
  userInfo: null
}

export const reducer = (state: State, action: UserActionTypes): State => {
  switch (action.type) {
    case UserTypes.SIGN_IN:
      return {
        ...state,
        token: action.payload.token,
        userInfo: action.payload.userInfo
      }
    case UserTypes.SIGN_OUT:
      return {
        ...state,
        token: null,
        userInfo: null
      }
    default:
      return state
  }
}

const getUser = (): State => {
  try {
    const user = localStorage.getItem('user')
    if (user && JSON.parse(user) && JSON.parse(user).token) {
      const token = JSON.parse(user).token
      axios.defaults.headers.common.Authorization = token
    }
    return user ? JSON.parse(user) : initialState
  } catch (e) {
    return initialState
  }
}

export const UserContextProvider = (props: IProps) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    const user = getUser()
    dispatch({ type: UserTypes.SIGN_IN, payload: { token: user.token, userInfo: user.userInfo } })
  }, [])

  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(state))
  }, [state])

  return <UserContext.Provider value={[state, dispatch]}>{props.children}</UserContext.Provider>
}
